import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungLeipzig() {
  return (
    <CityPageTemplate
      city="Leipzig"
      slug="leipzig"
      intro="Leipzig wächst rasant – jetzt ist der richtige Zeitpunkt, Vermögen aufzubauen und staatliche Förderungen zu nutzen."
      description="Unabhängige & digitale Finanzberatung für Leipzig: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
